import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=36da4e57"
import script from "./ClientSummary.vue?vue&type=script&lang=js"
export * from "./ClientSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports